import { Link } from "react-router-dom";

export function Logo({ testId }: { testId: string }) {
  return (
    <Link
      to="/"
      data-testid={testId}
      className="group inline-flex items-center gap-2 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950"
    >
      <span aria-hidden="true" className="h-2 w-2 rounded-full bg-emerald-500 transition-transform duration-200 group-hover:scale-125" />
      <span className="text-xl font-semibold tracking-tight text-slate-100">Gepeto</span>
    </Link>
  );
}
